import { Link, useNavigate } from "react-router-dom";
import { useAccount } from "../../app/account";
import { LoadingScreen, secondaryButtonClass } from "../../components/StatusScreen";
import { en } from "../../i18n/en";
import { AccountPage, FormError } from "./AccountPage";
import { NewPasswordForm } from "./NewPasswordForm";

const t = en.account.welcome;

/**
 * Opened from an invite link, which has already signed the person in (specs/11 FR-57): they
 * choose a password, or to use Google from now on.
 */
export function WelcomeScreen() {
  const { state, clearLinkEvent } = useAccount();
  const navigate = useNavigate();

  if (state.status === "checking") return <LoadingScreen />;
  if (state.status !== "signed-in") {
    return (
      <AccountPage title={t.title}>
        <div className="flex flex-col gap-4">
          <FormError>{t.invalid}</FormError>
          <Link to="/sign-in" className="text-center text-sky-400 underline">
            {en.account.reset.backToSignIn}
          </Link>
        </div>
      </AccountPage>
    );
  }

  const done = () => {
    clearLinkEvent();
    navigate("/", { replace: true });
  };

  return (
    <AccountPage title={t.title}>
      <p className="mb-4 text-slate-300">{t.body(state.account.email)}</p>
      <h2 className="mb-2 font-semibold">{t.setPassword}</h2>
      <NewPasswordForm label={t.newPassword} submitLabel={t.save} onSaved={done} />
      <p
        className="my-4 flex items-center gap-3 text-xs uppercase text-slate-500"
        aria-hidden="true"
      >
        <span className="h-px flex-1 bg-slate-700" />
        {en.account.signIn.or}
        <span className="h-px flex-1 bg-slate-700" />
      </p>
      <button type="button" onClick={done} className={`${secondaryButtonClass} w-full`}>
        {t.useGoogle}
      </button>
      <p className="mt-2 text-xs text-slate-400">{t.googleHint}</p>
    </AccountPage>
  );
}
